import { Subsection, SubsectionDto } from './subsections.types';

type ParseSubsectionsForUI = (input: SubsectionDto[]) => Subsection[];
type ParseSubsectionForUI = (input: SubsectionDto) => Subsection;

const parseSubsectionsListForUI: ParseSubsectionsForUI = raw => raw;

const parseSubsectionForUI: ParseSubsectionForUI = raw => raw;

export { parseSubsectionsListForUI, parseSubsectionForUI };
